import React from 'react';
import { Box, Ruler } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface CadViewerModeButtonProps {
  thicknessMode: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

const CadViewerModeButton: React.FC<CadViewerModeButtonProps> = ({
  thicknessMode,
  onToggle,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={onToggle}
      disabled={disabled}
    >
      {thicknessMode ? <Box /> : <Ruler />}
      {thicknessMode
        ? t('cad.modeSwitch.toViewer')
        : t('cad.modeSwitch.toThickness')}
    </Button>
  );
};

export default CadViewerModeButton;
